export default __webpack_public_path__ + "static/media/close_ic.a8ffc329.svg";